import React from "react";
import { components } from "react-select";
import { OnboardConstants } from "../../constants/constants";

const CustomMenuList = (props:any) => {

  return (
    <div>
        <div className="flex justify-end p-2 border-t border-gray-200">
        <button
          onClick={(e) => {
            e.stopPropagation();
          {props.clearAllOptions()} 
          }}
          className="mr-4 downloadSampleConsentText font-nunito underline cursor-pointer"
        >
          {OnboardConstants.clearAll}
        </button>
      </div>
      <components.MenuList {...props}>
        {/* Render the dropdown options */}
        {props.children}
      </components.MenuList>
      
    </div>
  );
};

export default CustomMenuList;